export default "__VITE_ASSET__Ca8JfoDO__"